import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";
import PersonIcon from '@mui/icons-material/Person';
import { makeStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import logo from "../Assets/Image/gsda_logo.jpg"
import LogoutIcon from '@mui/icons-material/Logout';
import * as Action from '../actions/adminAction';
import * as Auth from '../actions/authActions';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Profile from '../Assets/Image/Profile Admin.png'
import GroupIcon from '@mui/icons-material/Group';
import { Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import DomainIcon from '@mui/icons-material/Domain';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SettingsIcon from '@mui/icons-material/Settings';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


const drawerWidth = 240;

function RegionalLayout(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const { window } = props;
    const routePrefix = props.routePrefix || "/trainerLayout";
    const dashboardTitle = props.dashboardTitle || "Trainer Dashboard";
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [Agentopen, setAgentOpen] = React.useState(false);
    const [Bankopen, setBankopen] = React.useState(false);
    const [GSTopen, setGSTopen] = React.useState(false)

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const closeDrawer = () => {
        setMobileOpen(false);
    };

    const drawer = (
        <div>
            <Toolbar />
            <Divider />

            <List
                sx={{
                    height: '100%',
                }}
                style={{ marginTop: 50 }}
            >

                {/* //Assign District */}
                <ListItem
                    button
                    onClick={() => {
                        navigate(`${routePrefix}/view-assign-district`);
                        props.setActiveList(`${routePrefix}/view-assign-district`)
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}
                    style={props.ActiveList === `${routePrefix}/view-assign-district` ? {
                        backgroundColor: '#f4c03e',
                        border: '1px solid black',
                        color: 'white',
                        fontSize: 24
                    } : {
                        color: "white",
                    }}
                >
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><LocationCityIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 18 }} >All Assigned Districts</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>

                {/* Home/Rollout Plan */}
                <ListItem
                    onClick={() => {
                        navigate(`${routePrefix}/rolloutPlan`);
                        closeDrawer();
                        props.setActiveList(`${routePrefix}/rolloutPlan`);
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}
                    style={props.ActiveList?.toLowerCase() === `${routePrefix}/rolloutplan`.toLowerCase() ? {
                        backgroundColor: '#f4c03e',
                        border: '1px solid black',
                        color: 'white',
                        fontSize: 24
                    } : {
                        color: "white",
                    }}>
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><HomeIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 20 }} >Rollout Plan</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>

                {/* Approved Training  */}
                <ListItem
                    onClick={() => {
                        navigate(`${routePrefix}/approvedTrainer`)
                        closeDrawer();
                        props.setActiveList(`${routePrefix}/approvedTrainer`)
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}
                    style={props.ActiveList?.toLowerCase() === `${routePrefix}/approvedtrainer`.toLowerCase() ? {
                        backgroundColor: '#f4c03e',
                        border: '1px solid black',
                        color: 'white',
                        fontSize: 24
                    } : {
                        color: "white",
                    }}>
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><HomeIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 20 }} >Approved Training</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>

                {/* consolidated-report */}

                <ListItem
                    onClick={() => {
                        navigate(`${routePrefix}/consolidated-report`)
                        closeDrawer();
                        props.setActiveList(`${routePrefix}/consolidated-report`)
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}
                    style={props.ActiveList?.toLowerCase() === `${routePrefix}/consolidated-report`.toLowerCase() ? {
                        backgroundColor: '#f4c03e',
                        border: '1px solid black',
                        color: 'white',
                        fontSize: 24
                    } : {
                        color: "white",
                    }}>
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><HomeIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 20 }} >Monthly Approved Training</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>

                {/* Rejected Training  */}
                <ListItem
                    onClick={() => {
                        navigate(`${routePrefix}/rejectedTrainer`)
                        closeDrawer();
                        props.setActiveList(`${routePrefix}/rejectedTrainer`)
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}
                    style={props.ActiveList?.toLowerCase() === `${routePrefix}/rejectedtrainer`.toLowerCase() ? {
                        backgroundColor: '#f4c03e',
                        border: '1px solid black',
                        color: 'white',
                        fontSize: 24
                    } : {
                        color: "white",
                    }}

                >
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><ReceiptIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 20 }} >Pending Documents</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>

                {/* Add Beneficiary */}
                {/* <ListItem
          onClick={() => {
            navigate("/trainerlayout/addbeneficiary")
            closeDrawer();
            props.setActiveList("/trainerlayout/addbeneficiary")
          }}
          sx={{
            "&:hover": {
              backgroundColor: '#f4c03e',
              border: '1px solid black',
              fontSize: 24
            },
          }}
          style={props.ActiveList?.toLowerCase() === `${routePrefix}/addbeneficiary`.toLowerCase() ? {
            backgroundColor: '#f4c03e',
            border: '1px solid black',
            color: 'white',
            fontSize: 24
          } : {
            color: "white",
          }}

        >
          <div className={classes.back}>
            <ListItemButton>
              <ListItemIcon ><ReceiptIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
              <Typography style={{ fontSize: 20 }} >Add Beneficiary</Typography>
            </ListItemButton>
          </div>
        </ListItem> */}

                {/* Logout */}
                <ListItem
                    onClick={() => {
                        props.logout()
                        navigate("/")
                    }}
                    sx={{
                        "&:hover": {
                            backgroundColor: '#f4c03e',
                            border: '1px solid black',
                            fontSize: 24
                        },
                    }}

                    style={{ color: 'white' }}

                >
                    <div className={classes.back}>
                        <ListItemButton>
                            <ListItemIcon ><LogoutIcon style={{ color: 'white', fontSize: 30 }} /></ListItemIcon>
                            <Typography style={{ fontSize: 20 }} >LogOut</Typography>
                        </ListItemButton>
                    </div>
                </ListItem>
            </List>
            <Divider />
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    if (props.userDetails === null) {
        navigate("/")
    }

    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />

            <AppBar
                position="fixed"
                sx={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: "white",
                    zIndex: 1201,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: { xs: 1, sm: 2 },
                    padding: { xs: "6px 10px", sm: "6px 16px" },
                }}>

                <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                    <IconButton
                        color="primary"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 1, display: { xs: "inline-flex", md: "none" } }}>
                        <MenuIcon />
                    </IconButton>

                    <img
                        src={logo}
                        alt="GSDA"
                        style={{
                            width: "clamp(110px, 18vw, 200px)",
                            height: "clamp(42px, 10vw, 82px)",
                            objectFit: "contain",
                            margin: "0 6px",
                        }}
                    />
                </Box>

                <Typography
                    sx={{
                        display: { xs: "none", md: "block" },
                        flexGrow: 1,
                        color: "green",
                        fontSize: { md: 24, lg: 30 },
                        fontWeight: 600,
                        textAlign: "center",
                    }}
                >
                    {dashboardTitle}
                </Typography>
                <img
                    src={props.userDetails?.profilePicURL ? props.userDetails?.profilePicURL : Profile}
                    alt="Profile"
                    style={{
                        width: "clamp(40px, 5vw, 60px)",
                        height: "clamp(40px, 5vw, 60px)",
                        flexShrink: 0,
                        margin: "0 6px",
                        cursor: "pointer",
                        border: "1px solid black",
                        borderRadius: "50%",
                    }}
                    onClick={() => {
                        navigate(`${routePrefix}/profile`);
                        props.setActiveList(`${routePrefix}/profile`);
                    }}
                />

            </AppBar>


            <Box
                component="nav"
                sx={{ width: { xs: 0, md: drawerWidth }, flexShrink: 0 }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: "block", md: "none" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                            backgroundColor: '#1d5a96',
                        },

                    }}
                >
                    {drawer}
                </Drawer>

                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: "none", md: "block" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                            "::-webkit-scrollbar": {
                                display: "none",
                            },
                            backgroundColor: '#1d5a96',
                        },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    boxSizing: "border-box",
                    p: { xs: 1, sm: 2 },
                    width: { xs: "100%", md: "auto" },
                }}
            >
                <Toolbar sx={{ minHeight: { xs: 76, sm: 94 } }} />
                {/* <Typography paragraph> */}
                <Outlet style={{ overflow: 'auto' }} />
                {/* </Typography> */}
            </Box>
        </Box>
    );
}

RegionalLayout.propTypes = {
    window: PropTypes.func,
    routePrefix: PropTypes.string,
    dashboardTitle: PropTypes.string,
};
const useStyles = makeStyles((theme) => ({

    back: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        width: "180px",
        borderBottomLeftRadius: "30px",
        borderTopLeftRadius: "30px",
    },
    active: {
        backgroundColor: '#f4c03e',
        border: '1px solid black',
        // fontSize: 24
    }
}));

const mapStateToProps = (state) => {
    return {
        ActiveList: state.admin.ActiveList,
        userDetails: state.auth.userDetails,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setActiveList: (data) => dispatch(Action.setActiveList(data)),
        logout: () => dispatch(Auth.logout()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegionalLayout)
